var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content.type == 1)?_c('LandingBase',{attrs:{"content":_vm.content,"numberApplications":_vm.numberApplications}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.landingContent)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }